// import { BUILD_ENV } from 'utils/global'
import { addScript } from 'utils/helpers'
import router from 'utils/router'
import { isPivo } from 'utils/isPivo'

const GA_IDS = {
  itaucard: '59L26PJ',
  vitrine: 'MGJ5DBD',
  recovery: 'NSJJGTX',
  'reneg-itau': 'WLR7NT3',
}

export default function loadAnalyticsData(payload) {
  const utmSource = router.getQueryString('utm_source')
  const GTMID = GA_IDS[utmSource] || GA_IDS['recovery']
  const LIBS_FRAMEWORKDA_URL = `https://www.itau.com.br/_arquivosestaticos/Itau/defaultTheme/js/da/framework/importLibJSFrameworkDA.js?${GTMID}`
  const FRAMEWORKDA_URL = `https://www.itau.com.br/_arquivosestaticos/Itau/defaultTheme/js/da/framework/frameworkDA.js?${GTMID}`

  if (!isPivo()) {
    addScript(LIBS_FRAMEWORKDA_URL, 'importLibJSFrameworkDA')
      .then(() => addScript(FRAMEWORKDA_URL, 'frameworkDA'))
      .then(() => {
        window.analyticsData = payload
        window._frameworkDA.Track()
      })
  }
}
